import React from "react";

const MESSAGES = ["Free shipping on orders over $75", "Clean ingredients", "Easy returns"];

function MessageGroup({ hidden }) {
  return (
    <div className="flex items-center flex-shrink-0" aria-hidden={hidden || undefined}>
      {[0, 1, 2].flatMap((r) =>
        MESSAGES.map((m) => (
          <span key={`${r}-${m}`} className="flex items-center">
            <span className="px-6 sm:px-10 whitespace-nowrap">{m}</span>
            <span className="w-1 h-1 rounded-full bg-white/60" />
          </span>
        ))
      )}
    </div>
  );
}

/* Slim black strip with slowly scrolling messages */
export default function HomeAnnouncement() {
  return (
    <div className="bg-[#111111] text-white overflow-hidden py-2" data-testid="announcement-banner" aria-label="Store announcements">
      <div className="doria-marquee flex w-max text-[11px] sm:text-[12px] leading-4 font-sans font-bold tracking-[0.16em] uppercase">
        <MessageGroup />
        <MessageGroup hidden />
      </div>
    </div>
  );
}
